<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">Alterar Senha</h4>
      </div>
      <div>
        <fg-input
          name="oldPassword"
          label="Senha Atual"
          v-validate="modelValidations.oldPassword"
          v-model="model.oldPassword"
          :error="getError('oldPassword')"
          type="password"
        ></fg-input>
        <fg-input
          name="newPassword"
          label="Nova Senha"
          v-validate="modelValidations.newPassword"
          v-model="model.newPassword"
          :error="getError('newPassword')"
          ref="newPassword"
          type="password"
        ></fg-input>
        <fg-input
          name="repeatNewPassword"
          label="Repita a Nova Senha"
          v-validate="modelValidations.repeatNewPassword"
          v-model="model.repeatNewPassword"
          :error="getError('repeatNewPassword')"
          type="password"
        ></fg-input>
      </div>
    </card>
    <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>
  </form>
</template>
<script>
export default {
  data() {
    return {
      crud: "Editar",
      model: {
        oldPassword: "",
        newPassword: "",
        repeatNewPassword: ""
      },
      modelValidations: {
        oldPassword: {
          required: true
        },
        newPassword: {
          required: true
        },
        repeatNewPassword: {
          required: true,
          confirmed: "newPassword"
        }
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Senha alterada!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Senha incorreta!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    async validate() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        try {
          await this.$store.dispatch("auth/changePassword", {
            item: {
              old_password: this.model.oldPassword,
              new_password: this.model.newPassword
            }
          });
          this.notifySuccess();
        } catch (err) {
          this.notifyError();
        }
      }
    }
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
